import styled from 'styled-components'
import isNumber from 'lodash/isNumber'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-top: none;
  flex: 1;
  overflow: ${(props) => (props.overflow ? 'auto' : null)};
`

export const DetailsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: ${(props) => (props.ordinary ? 'column' : null)};
  width: ${(props) => (props.ordinary ? '100%' : null)};
  padding: ${(props) => (props.ordinary ? '0' : null)};
`

export const PlainTextContainer = styled.div`
  border: 1px solid rgba(34, 36, 38, 0.15);
  padding: 0.5em;
  line-height: 1em;
  border-radius: 0.28571429rem;
  min-height: 33px;
`

export const ComponentContainer = styled.div`
  flex: ${(props) => (props.flex ? 1 : null)};
  display: ${(props) => (props.flex ? 'flex' : null)};
  min-width: ${(props) => (props.flex ? 0 : null)};
  width: ${(props) => (props.autoWidth ? 'auto' : '100%')};

  & textarea {
    border-radius: ${(props) => (props.textArea ? '4px' : null)};
    border-color: ${(props) => (props.textArea ? '#dedede' : null)};
    padding: ${(props) => (props.textArea && props.small ? '0.5em !important' : null)};
    height: ${(props) => (props.height ? `${props.height}px` : 'auto')};
    resize: ${(props) => (props.noResize ? 'none' : 'vertical')};
  }

  & .input input {
    padding: ${(props) => (props.input ? '0.5em !important' : null)};
    min-height: ${(props) => (props.input ? '33px' : null)};
  }

  & .ui.selection.dropdown {
    padding: ${(props) => (props.dropdown ? '0.5em' : null)};
    min-height: 33px;
    line-height: initial;
    padding-bottom: 0px;
    min-width: unset;

    &.failed-field {
      ${(props) =>
        props.active
          ? 'box-shadow: 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 1px -1px rgba(0,0,0,.2), 0 1px 0px 0 rgba(0,0,0,.12)'
          : ''};
    }
  }

  & .ui.search.selection.dropdown > .search {
    padding: ${(props) => (props.dropdown ? 'inherit' : null)};
  }

  & .ui.selection.dropdown > .icon {
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    margin: 0;
  }

  & .ui.dropdown .menu {
    width: ${(props) => (props.menuWidth ? `${props.menuWidth}px` : 'auto')};
    right: ${(props) => (props.floatLeft ? '0px' : null)};
    left: ${(props) => (props.floatLeft ? 'auto' : null)};
  }

  & .ui.dropdown .menu > .item {
    white-space: ${(props) => (!props.menuWidth ? 'nowrap' : null)};
  }

  & .ui.search.dropdown .menu {
    max-height: ${(props) =>
      props.children && props.children.props && props.children.props.maxHeight
        ? `${props.children.props.maxHeight}rem !important`
        : '21.37142857rem !important'};
    ${(props) => isNumber(props.visibleItemsCount) && `max-height: ${props.visibleItemsCount * 23}px !important`}
  }

  & .ui.selection.dropdown .menu > .item {
    padding: 0.3em !important;
  }

  & .ui.selection.dropdown > .text {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding-right: 25px;
  }

  & [class^='fieldGroup_'] {
    border-radius: ${(props) => (props.calendar ? '.28571429rem' : null)};
    height: ${(props) => (props.calendar ? 29 : 32)};
  }

  & [class^='fieldGroup_'] input {
    border-radius: ${(props) => (props.calendar ? '4px' : null)};
    border: none !important;
  }

  & [class^='ms-DatePicker'] {
    margin-bottom: ${(props) => (props.calendar ? '0px' : null)};
  }

  & [class^='ms-TextField'] {
    margin-bottom: ${(props) => (props.calendar ? '0px' : null)};
  }

  & [class^='ms-TextField-field'] {
    padding-top: ${(props) => (props.calendar ? '11px !important' : null)};
    padding-bottom: ${(props) => (props.calendar ? '9px !important' : null)};
  }
`

export const FlexContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;

  & > .segment {
    padding: 0;
  }
`

export const ColumnContentContainer = styled.div`
  position: relative;
  overflow: hidden;
  white-space: nowrap;
`

export const TextMiddleContainer = styled.div`
  height: auto;
  padding-top: 18%;
`
